const formatter = (value, unit, suffix) => {
    if (unit === "second") {
        return `less than one min ago`;
    }
    return value + " " + unit.substr(0, 3) + (value > 1 ? "s" : "") + " " + suffix;
};

export default formatter;
